import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ImageOff } from "lucide-react";
import { AuthImage } from "./AuthImage";

const MAX_THUMBS = 3;

function HoverCard({ item, top, left }) {
  return (
    <div className="fixed z-[80] pointer-events-none bg-white rounded-lg shadow-xl border border-zinc-200 p-2 w-[216px]" style={{ top, left }} data-testid="fabric-hover-card">
      {item.url ? (
        <AuthImage src={item.url} alt={item.label} className="w-[200px] h-[125px] object-cover rounded-md border border-zinc-200" />
      ) : (
        <div className="w-[200px] h-[125px] rounded-md border-2 border-dashed border-red-300 bg-red-50 flex flex-col items-center justify-center text-red-500">
          <ImageOff className="w-5 h-5" /><span className="text-xs font-semibold mt-1">Photo manquante</span>
        </div>
      )}
      {item.code && <p className="font-bold text-zinc-900 tracking-wide mt-1.5 leading-tight">{item.code}</p>}
      <p className="text-xs text-zinc-500 truncate">{item.code ? item.collection || "Collection inconnue" : item.label}</p>
    </div>
  );
}

// FABRIC column cell: one thumbnail per fabric found in CONTENT (max 3, then "+N").
export function FabricCell({ items, onOpen, testId }) {
  const [hover, setHover] = useState(null);
  if (!items?.length) return null;
  const shown = items.slice(0, MAX_THUMBS);
  const extra = items.length - shown.length;
  const open = (e) => { e.stopPropagation(); setHover(null); onOpen(e); };
  const showHover = (e, item) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const below = rect.bottom + 180 < window.innerHeight;
    setHover({ item, top: below ? rect.bottom + 6 : rect.top - 186, left: Math.min(rect.left, window.innerWidth - 230) });
  };

  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {shown.map((item, i) => (
        <button key={item.id} type="button" onClick={open} onDoubleClick={(e) => e.stopPropagation()}
          onMouseEnter={(e) => showHover(e, item)} onMouseLeave={() => setHover(null)}
          className="flex-shrink-0 rounded transition-transform duration-150 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-orange-400"
          data-testid={`${testId}-thumb-${i}`}>
          {item.url ? (
            <AuthImage src={item.url} alt={item.label} className="w-9 h-6 object-cover rounded border border-zinc-300" />
          ) : (
            <span className="w-9 h-6 rounded border border-dashed border-red-400 bg-red-50 text-red-500 text-[10px] font-bold flex items-center justify-center">?</span>
          )}
        </button>
      ))}
      {extra > 0 && (
        <button type="button" onClick={open} className="text-[11px] font-semibold text-zinc-500 hover:text-orange-600 px-0.5" data-testid={`${testId}-more`}>+{extra}</button>
      )}
      {hover && createPortal(<HoverCard {...hover} />, document.body)}
    </div>
  );
}
